import React from 'react';
import { MapPin, Phone } from 'lucide-react';

export const USOfficeContact = () => (
  <section
    aria-labelledby="us-office-heading"
    data-testid="us-office-contact"
    className="mt-10 pt-8 border-t border-gray-200"
  >
    <h3 id="us-office-heading" data-testid="us-office-heading" className="text-lg font-bold text-gray-900 mb-3">
      US Office
    </h3>
    <p data-testid="us-office-contact-name" className="font-semibold text-gray-900">Amar Reddy</p>
    <p data-testid="us-office-contact-role" className="text-emerald-600 mb-6">Managing Partner</p>
    <address className="not-italic space-y-6">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
          <MapPin aria-hidden="true" className="w-6 h-6 text-emerald-600" />
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900">Address</p>
          <p data-testid="us-office-address" className="text-gray-600">
            21495 Ridgetop Circle<br />
            Sterling, VA 20166, USA
          </p>
        </div>
      </div>
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
          <Phone aria-hidden="true" className="w-6 h-6 text-emerald-600" />
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900">Phone</p>
          <a
            href="tel:+14126525040"
            data-testid="us-office-phone-link"
            className="inline-block py-1 text-emerald-600 hover:text-emerald-700 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-emerald-600"
          >
            +1 (412) 652-5040
          </a>
        </div>
      </div>
    </address>
  </section>
);